


export interface ColorTypeInterface {

    getId(): string;
    getCode(): string;
    getType(): string;
    isEmpty(): boolean;


}

export class ColorType implements ColorTypeInterface{

    constructor(private  data :{id: string, code: string, type: string}){

        this.data.type.trim();
    }

    getCode(): string {
        return this.data.code;
    }

    getId(): string {
        return this.data.id;
    }
    getType(): string {
        return this.data.type;
    }

    isEmpty(): boolean {
        return this.data.type == "";
    }

}



export class ColorTypeSingleton {

    private items: ColorType[];
    private static _instance : ColorTypeSingleton;
    private defaultColor: ColorTypeInterface;
    private colors:[string, string, string][] = [
        [
            //30
            'berry_red'
            , "#b8255f"
            , ""],
        [
            //40
            'light_blue'
            , "#96c3eb", ""],
        ['red', "#db4035", ""],
        ['blue', "#4073ff", "Работа"],
        ['orange', "#ff9933", "Развитие"],
        ['grape', "#884dff", ""],
        ['yellow', "#fad000", ""],
        ['violet', "#af38eb", ""],
        ['olive_green', "#afb83b", ""],
        ['lavender', "#eb96eb", ""],
        ['lime_green', "#7ecc49", ""],
        ['magenta', "#e05194", "Семья"],
        ['green', "#299438", "Freelance"],
        ['salmon', "#ff8d85", ""],
        ['mint_green', "#6accbc", ""],
        ['charcoal', "#808080", ""],
        ['teal', "#158fad", ""],
        ['grey', "#b8b8b8", ""],
        ['sky_blue', "#14aaf5", ""],
        ['taupe', "#ccac93", ""],];


    private constructor(){

        this.defaultColor = new ColorType({id: "", code: "", type: "None"});
        this.items = [];
        this.colors.forEach((color) => {
            let colorType = {id: color[0], code: color[1], type: color[2]};
            this.addItem(new ColorType(colorType));

        })


    }


    getById(id: number|string): null | ColorType{
         let color: ColorType[] = this.items.filter(function (color) {
            return id == color.getId()
        })
        return color.length ? color[0] : null;
    }

    private addItem(color: ColorType){
        this.items.push(color);
    }
    getItems(){
        return this.items;
    }

    public getDefaultColor(){
        return this.defaultColor;
    }

    public static getInstance() :ColorTypeSingleton {
        if (ColorTypeSingleton._instance) {
            return ColorTypeSingleton._instance;
        }
        return ColorTypeSingleton._instance = new ColorTypeSingleton;
    }



}

// 30	#b8255f #b8256f		40	#96c3eb #96c3eb
// 31	#db4035 #db4035		41	#4073ff #4073ff
// 32	#ff9933 #ff9933		42	#884dff #884dff
// 33	#fad000 #fad000		43	#af38eb #af38eb
// 34	#afb83b #afb83b		44	#eb96eb #eb96eb
// 35	#7ecc49 #7ecc49		45	#e05194 #e05194
// 36	#299438 #299438		46	#ff8d85 #ff8d85
// 37	#6accbc #6accbc		47	#808080 #808080
// 38	#158fad #158fad		48	#b8b8b8 #b8b8b8
// 39	#14aaf5 #14aaf5		49	#ccac93 #ccac93
